// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__2TzZR","summary":"CartItem_summary__2H3Hv","price":"CartItem_price__1WuI3","amount":"CartItem_amount__1eVAG","actions":"CartItem_actions__21TYY"};